import { useEffect, useState } from "react";
import {
  t,
  translate,
} from "components/CentralDataMangement/translation/Translation";
import { Modal } from "react-bootstrap";
import { ApiCall } from "components/common/services/ApiServices";
import { AJ_WEB_CONNECTOR } from "Constants";
import { GENERATE_CONTENT_BY_MODIFIED_PROMPT, GET_USER_PROMPT } from "routes/ApiEndpoints";
import { LabelWithInputField } from "../molecules/LabelWithInputField";
import Button from "../atoms/Button";
import { ValidationRules } from "../utlis/TypeAnnotations";
import { validateForm, validateRequired } from "../services/ValidationService";
import { convertMarkdownToHtml } from "../utlis/HelperFunctions";
import LabelWithCKEditorField from "../molecules/LabelWithCKEditorField";
import LabelWithTextAreaField from "../molecules/LabelWithTextAreaField";
import secureLocalStorage from "react-secure-storage";
import {
  setLanguage,
  getLanguage,
} from "components/CentralDataMangement/translation/Translation";
import * as CONST from "Constants";
import SelectWithSearch from "../atoms/SelectWithSearch";
import CustomNotify from "components/common/atoms/CustomNotify";

export interface ContentGenerationProps {
  prompt: string;
  content: string;
  slug: string | null;
  comments: string;
}

export type ContentGenerationErrors = {
  [K in keyof ContentGenerationProps]?: string; // Allow string error messages
};

type TokenObject = Record<string, string>;

export interface GenerateContentData {
  currentField: string;
  isOpen: boolean;
}

type PromptKey = any;

interface ContentGenerationPopupProps {
  contentType: PromptKey;
  slug: any;
  isCkEditor: boolean;
  promptVariables?: Record<string, string>;
  show: boolean;
  popupSize?: "sm" | "lg" | "xl";
  numberOfWords?: number | null;
  onHide: () => void;
  addContent: (content: string) => void;
}

const ContentGenerationPopup: React.FC<ContentGenerationPopupProps> = ({
  contentType,
  slug,
  isCkEditor = false,
  promptVariables = {},
  popupSize = "xl",
  numberOfWords,
  show,
  onHide,
  addContent,
}) => {

  const getPrompt = async (key: PromptKey,value: any) => {
    const data = {
      promptType: key,
      slug: value
    }
    const response = await ApiCall.service(
      GET_USER_PROMPT,
      "POST",
      data,
      true,
      AJ_WEB_CONNECTOR
    );
    if (response?.status === "success") {
      const res = response.data;
      const promptData = replaceTokens(res.content, promptVariables)
      setState((prevData) => ({
        ...prevData,
        prompt: promptData,
        slug: res.slug
      }));

      return response.data;
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
  }
  const [languages, setLanguages] = useState<
    Array<{ id: number; key: string; name: string }>
  >([]);

  function replaceTokens(template: string, data: TokenObject): string {
    return template.replace(/{{(.*?)}}/g, (_, key) => {
      const trimmedKey = key.trim();
      return data[trimmedKey] || ""; // replace with value or empty string
    });
  }
  // const expLevel = promptVariables.experience_level?.trim().toLowerCase() || "";

  // promptVariables.experience_sentence =
  //   expLevel === "Select" || expLevel === "no" || expLevel === ""
  //     ? "You are eager to learn and ready to quickly gain experience in this role."
  //     : `You have ${promptVariables.experience_level} of experience in this role.`;

  // const promptDetails = getPrompt(contentType);
 useEffect(() => {
    getPrompt(contentType,slug);
  }, [contentType]);
  const [state, setState] = useState<ContentGenerationProps>({
    content: "",
    // prompt: replaceTokens(promptDetails.content, promptVariables),
    prompt: "",
    slug: "",
    // slug: promptDetails.slug,
    comments: "",
  });

  const [contentGenerationErrors, setContentGenerationErrors] = useState<
    Partial<ContentGenerationErrors>
  >({});
  const [hasGeneratedContent, setHasGeneratedContent] =
    useState<boolean>(false); // ADDED: Track if content has been generated

  const validateTaskField = (
    formData: ContentGenerationProps,
    name: string,
    value: string,
    setErrors: React.Dispatch<React.SetStateAction<ContentGenerationErrors>>,
    isSingleFieldValidation: boolean = false
  ) => {
    const validationRules: ValidationRules = {
      prompt: [validateRequired],
    };

    const validationErrors = validateForm(
      { ...formData, [name]: value },
      validationRules,
      isSingleFieldValidation ? name : undefined
    );

    if (isSingleFieldValidation && Object.keys(validationErrors).length > 0) {
      setContentGenerationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationErrors[name],
      }));
    } else {
      setContentGenerationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationErrors[name],
      }));
    }

    if (Object.keys(validationErrors).length > 0) {
      return false;
    }
    return true;
  };

  const generateContent = async () => {
    const isValid = validateTaskField(
      state,
      "prompt",
      state.prompt,
      setContentGenerationErrors,
      true
    );

    if (isValid) {
      // MODIFIED: Enhanced prompt logic to handle comments and modifications
      let finalPrompt = state.prompt;
      // If there are comments and content already exists, append modification instructions
      // if (state.comments.trim() !== "" && hasGeneratedContent) {
      if (hasGeneratedContent) {
        // finalPrompt += ` \n Please modify the previously generated content based on these comments: ${state.comments.trim()}\nCheck here for previously generated response: ${state.content.trim()}`;
        finalPrompt += `
          \n Regenerate the previously generated content.

          ${state.comments.trim() !== ""
          ? `\n Modify based on these comments: ${state.comments.trim()}`
          : `\n Improve wording and regenerate with same structure.`}

          \n Check here for previously generated response:
          ${state.content.trim()}
          `;
      }
      // Add word count constraint if specified
      if (numberOfWords) {
        finalPrompt += ` Give the response in ${numberOfWords} words.`;
      }

      const entity = {
        provider_slug: "openai",
        model_slug: "gpt-4o",
        prompt: finalPrompt, // MODIFIED: Use finalPrompt instead of conditional prompt
        slug: state.slug,
        content_type: contentType,
        variables: promptVariables,
        options: {
          temperature:
            contentType === "present_candidate_to_client" ||
              contentType === "present_vacancy_to_candidate"
              ? 0.6
              : 0.7,
          max_tokens: 1000,
        },
        lang: activeLanguage,
      };

      const response = await ApiCall.service(
        GENERATE_CONTENT_BY_MODIFIED_PROMPT,
        "POST",
        entity,
        true,
        AJ_WEB_CONNECTOR
      );

      if (response?.status === "success") {
        const resData = response?.data;
        const htmlContent = await convertMarkdownToHtml(resData?.content);
        if (isCkEditor) {
          setState((prevData) => ({ ...prevData, content: htmlContent }));
        } else {
          // Replace common block-level tags with line breaks
          const withLineBreaks = htmlContent
            .replace(/<\/(p|h[1-6]|li|ul|ol|div)>/gi, "\n")
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/<li>/gi, "- ")
            .replace(/<[^>]+>/g, "") // Remove all remaining HTML tags
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/\r?\n\s*\n/g, "\n") // Remove blank lines caused by block spacing
            .replace(/\n{2,}/g, "\n") // Collapse multiple newlines into one
            .trim();
          setState((prevData) => ({ ...prevData, content: withLineBreaks }));
        }

        // ADDED: Mark that content has been generated and clear comments after successful generation
        setHasGeneratedContent(true);
        setState((prevData) => ({ ...prevData, comments: "" }));
      } else {
        CustomNotify({
          type: "error",
          message: t("Some error occured"),
        });
      }
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    validateTaskField(state, name, value, setContentGenerationErrors, true);
    setState((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCKEditorChange = (event: any, editor: any, fieldName: string) => {
    const content = editor.getData(); // Get the content from the editor
    setState((prevData) => ({
      ...prevData,
      [fieldName]: content,
    }));
  };
  const languageOptions = languages?.map((language) => ({
    label: language.key.toUpperCase(),
    value: language.key,
  }));
  const appLangKey = secureLocalStorage.getItem("site_lang") ?? "en-source";
  const initialLang = {
    label: appLangKey,
    value: appLangKey,
  };
  const [activeLanguage, setActiveLanguage] = useState(initialLang);
  const handleLangChange = (selectedOption: {
    label: string;
    value: string;
  }) => {
    setActiveLanguage(selectedOption);
  };

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    const response = await ApiCall.getService(
      "getAppLang/absolute_jobs",
      "GET",
      CONST.CENTRAL_DATA_MANAGEMENT_MICROSERVICE
    );
    if (response?.status === 200) {
      setLanguages(response?.app_langs);
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occured"),
      });
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        size={"xl"}
        backdrop="static"
        className="contentCreationModal"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0">
          <div className="modal-title"></div>
        </Modal.Header>
        <Modal.Body className="px-0 border-0">
          <div className="prompt-content">
            <LabelWithTextAreaField
              name="prompt"
              handleChange={handleChange}
              label={t("Prompt")}
              value={state.prompt}
              isMandatory={true}
              error={contentGenerationErrors.prompt}
            />
          </div>
          <div className="lang-options-content w-50">
            <SelectWithSearch
              options={languageOptions}
              value={activeLanguage}
              onChange={handleLangChange}
              search={true}
              name="lang"
              title={t("Select language to generate response")}
            />
          </div>
          <div className="position-relative content-generation-lang">
            <div
              className="hideHeight hideLabel"
              style={{ marginBottom: "1.5vw" }}
            >
              {isCkEditor ? (
                <LabelWithCKEditorField
                  name="content"
                  value={state.content}
                  placeholder={t("Type here") + "..."}
                  handleChange={(event, editor) =>
                    handleCKEditorChange(event, editor, "content")
                  }
                  className="field-shadow"
                />
              ) : (
                <LabelWithTextAreaField
                  name="content"
                  value={state.content}
                  handleChange={handleChange}
                />
              )}
            </div>
          </div>
          {/* ADDED: Comments section that appears only after content has been generated */}
          {hasGeneratedContent && (
            <div
              className="hideHeight hideLabel"
              style={{ marginBottom: "1.5vw" }}
            >
              <LabelWithTextAreaField
                name="comments"
                value={state.comments}
                handleChange={handleChange}
                label={t("Comments for modification")}
                placeholder={
                  t("Enter your comments to modify the generated content...") +
                  "..."
                }
              />
            </div>
          )}

          <div className="text-end">
            {state.prompt && state.prompt.trim() !== "" ? (
              <Button
                title={t("Add this content")}
                handleClick={() => {
                  addContent(state.content);
                }}
                className="form-button marginRight1"
              />
            ) : (
              <></>
            )}
            {/* MODIFIED: Dynamic button text based on whether content exists and comments are provided */}
            <Button
              title={
                hasGeneratedContent && state.comments.trim() !== ""
                  ? t("Regenerate with comments")
                  : t("Generate content")
              }
              handleClick={generateContent}
              className="form-button"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default translate(ContentGenerationPopup);
